export const baseStyles = {
  cellPadding: 4,
  paddingLeft: 16,
};

export const filterWrapperStyles = {
  padding: baseStyles.cellPadding,
  paddingLeft: 0,
  paddingTop: 0,
  paddingRight: 8,
};
